import { useVesselVesselContext } from "./vesselVesselContext";

export function useVesselVesselStore() {
  return useVesselVesselContext();
}
